export enum TaskStatus {
  toDo = 'TODO',
  done = 'DONE',
  supplierInvoice = 'SUPPLIER_INVOICE',
  incomingCases = 'INCOMING_CASES',
  refund = 'REFUND'
}

export enum TaskType {
  manual = 'MANUAL',
  automatic = 'AUTOMATIC',
  medical = 'MEDICAL',
  sms = 'SMS',
  email = 'EMAIL',
  fax = 'FAX',
  mms = 'MMS',
  customerNote = 'CUSTOMER_NOTE',
  suplierInvoice = 'SUPPLIER_INVOICE',
  refund = 'REFUND',
  consent = 'CONSENT',
  external = 'EXTERNAL',
  supplierNote = 'SUPPLIER_NOTE',
  process = 'PROCESS',
  processGopRequest = 'PROCESS_GOP_REQUEST'
}
